import axiosPrivate from "@services/axiosPrivate"

export const getAdSetByCampaignId = async (campaignId) => {
  const response = await axiosPrivate.get(`${campaignId}/adsets`, {
    params: {
      fields:
        "name,status,targeting,daily_budget,bid_strategy,optimization_goal,ads.limit(50)",
      limit: 500,
    },
  })
  return response.data
}
